import { render, staticRenderFns } from "./TotalesHorizontal.vue?vue&type=template&id=1a44182a&"
import script from "./TotalesHorizontal.vue?vue&type=script&lang=js&"
export * from "./TotalesHorizontal.vue?vue&type=script&lang=js&"
import style0 from "./TotalesHorizontal.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/franciscoriquelme/Documents/Elipse.ia/Proyectos/elipse-citas/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('1a44182a')) {
      api.createRecord('1a44182a', component.options)
    } else {
      api.reload('1a44182a', component.options)
    }
    module.hot.accept("./TotalesHorizontal.vue?vue&type=template&id=1a44182a&", function () {
      api.rerender('1a44182a', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/js/vue/components/DashboardReportNMV/components/TotalesHorizontal.vue"
export default component.exports